/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {
    NineToFiveGameData,
    NineToFiveInitData,
    isNineToFiveGameData,
    SymbolValues,
    WinData,
    WinLineData
} from "./NineToFiveData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {StateMatrix} from "../utils/StateMatrix";
import {NineToFiveSymbolStates} from "../reels/symbols/NineToFiveSymbol";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {NineToFive} from "../NineToFive";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

// first attempt at doing big symbols, probably not a very good one :joy:
export interface BigSymbolData {
   haveBigSymbol:boolean;
   topToBottom:boolean;
   actualSymbolIndex:number;
   //visibleSymbolHeight:number;
}


export class NineToFiveModel extends GameModel<NineToFiveInitData, NineToFiveGameData> {

    public isRestore:boolean = false;
    //public visibleReelMatrix:StateMatrix<string>;
    //public evaluatedArea:StateMatrix<string>;
    public winData:WinData;
    public isRestoreFeatureBet:boolean;
    public buyFeatureName:string;
    public symbolValues?:SymbolValues;
    public totalWays:number;
    public xWaysSize:number;
    public bigSymbolData:BigSymbolData[];
    // hackjob for if we get a max win in the freespins outro and have won something in the base game spin
    public nonFreespinMultipliedAccumlatedWin:number;
    public isFreespinsOutroMaxWin:boolean;

    public hasWonFsClient:boolean = false;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureBet", (data:boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data:string) => {
            this.buyFeatureName = data;
        });
        NineToFive.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < NineToFive.model.initData.featureBuyTimesBetValue.length; index++) {
                if (NineToFive.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });

        NineToFive.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < NineToFive.model.initData.featureBuyTimesBetValue.length; index++) {
                if (NineToFive.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
    }

    protected onInit(data:NineToFiveInitData):void {
        console.log("INIT DATA", data);
        super.onInit(data);
        this.symbolValues = data.symbolValues;
        this.isRestore = data.isRestoreState;

        this.bigSymbolData = data.reels.map((reel) => this.calculateBigSymbol(reel));
        if (this.isRestore) {
            this.nonFreespinMultipliedAccumlatedWin = data.accumulatedRoundWin;
        }
    }

    public onGame(data:NineToFiveGameData):void {
        console.log("GAME DATA", data);
        super.onGame(data);
        this.isRestore = false;
        this.winData = this.createWinData(data,
                                          new StateMatrix<string>(data.reels.map((reel) => reel.slice(1,5))),
                                          new StateMatrix<string>(data.evaluatedArea) )
        this.totalWays = this.gameData.betWayWins
            .map((win) => win.numberOfCombinations)
            .reduce((a,b) => a+b, 0);
        this.xWaysSize = this.gameData.symbolSizes
            .reduce((a,b) => a.concat(b), [])
            .reduce((a,b) => Math.max(a,b), 1);
        this.bigSymbolData = data.reels.map((reel) => this.calculateBigSymbol(reel));
        this.isFreespinsOutroMaxWin =
            NineToFive.model.nonFreespinMultipliedAccumlatedWin < NineToFive.model.data.accumulatedRoundWin;
    }

    private calculateBigSymbol(symbols:string[]):BigSymbolData {
        const bigSymbolName = symbols.some((sym) => sym == "XN") ? "XN" : symbols.some((sym) => "C") ? "C" : ""
        let haveBigSymbol = bigSymbolName != "";
        let topToBottom = true;
        let actualSymbolIndex = -1;
        //let visibleSymbolHeight = 0;

        if (haveBigSymbol) {
            //const visibleSymbolHeight = symbols.reduce((sym) => sym == bigSymbolName ? 1 : 0, 0);
            const visibleSymbolHeight = (<number[]>symbols.map((sym) => sym == bigSymbolName ? 1 : 0 ))
                                        .reduce((a,b) => a + b, 0);
            const firstIndex = symbols.indexOf(bigSymbolName);
            const lastIndex = firstIndex + visibleSymbolHeight - 1;
            topToBottom = lastIndex > 3;
            actualSymbolIndex = topToBottom ? firstIndex : lastIndex;
            haveBigSymbol = actualSymbolIndex != 5 && actualSymbolIndex != 0;
        }

        return {
            haveBigSymbol: haveBigSymbol,
            topToBottom: topToBottom,
            actualSymbolIndex: actualSymbolIndex,
            //visibleSymbolHeight: visibleSymbolHeight,
        };
    }

    private calculateTotalWays(data:NineToFiveGameData):number {
        return this.gameData.betWayWins.map((win) => win.numberOfCombinations).reduce((a,b) => a+b, 0);
    }

    public createWinData(data:NineToFiveGameData, visibleReelMatrix:StateMatrix<string>, evaluatedArea:StateMatrix<string>):WinData {
        const winLines:WinLineData[] = [];
        const winMatrix = new StateMatrix<NineToFiveSymbolStates>();
        winMatrix.initWithValueAndMatchDimensionsFromMatrix(NineToFiveSymbolStates.NO_WIN, visibleReelMatrix.matrix);

        //const winRatio = data.totalSpinWinnings / data.playedBetValue;
        //const accumulatedWinRatio = data.accumulatedRoundWin / data.playedBetValue;

        let winWays = 0;
        if (isNineToFiveGameData(data)) {
            for (let win of data.betWayWins) {
                winWays += win.numberOfCombinations;
                let matchingSymbols = [win.symbol, "W", "XN"];

                const lineMatrix:StateMatrix<boolean> = new StateMatrix();
                lineMatrix.initWithValueAndMatchDimensionsFromMatrix(false, evaluatedArea.matrix);
                const lineData:WinLineData = {
                    betWayWin:win,
                    coordinates:[],
                    matrix:lineMatrix,
                }

                lineData.coordinates = evaluatedArea.getAllCoordinatesWhere((value:string, column:number, row:number) => {
                    //return matchingSymbols.indexOf(value) >= 0 && column < win.length;
                    return matchingSymbols.indexOf(value) >= 0 &&
                                           column < win.length &&
                                           NineToFive.model.data.symbolSizes[column][row] != 0;
                });

                winMatrix.setValueForCoordinates(lineData.coordinates, NineToFiveSymbolStates.WIN_TINY);
                lineMatrix.setValueForCoordinates(lineData.coordinates, true);
                winLines.push(lineData);
            }
        }

        const clientTotalSpinWinnings = data.betWayWins.map((win) => win.multipliedAmount).reduce((a,b) => a+b, 0);
        const winRatio =  clientTotalSpinWinnings / data.playedBetValue;
        if (data.mode != GameMode.NORMAL && data.nextMode == GameMode.NORMAL) {
            this.nonFreespinMultipliedAccumlatedWin += clientTotalSpinWinnings;
        } else {
            this.nonFreespinMultipliedAccumlatedWin = data.accumulatedRoundWin;
        }

        return {
            lines:winLines,
            matrix:winMatrix,
            winWays:winWays,
            winRatio:winRatio,
            //accumulatedWinRatio:accumulatedWinRatio,
            accumulatedWin:data.accumulatedRoundWin,
            nonFreespinsMultipliedWin: clientTotalSpinWinnings,
        }
    }

    public isBoostedBet():boolean {
        const activeFeature = NineToFive.apiPlugin.betFeatureController.getActiveBetFeature();
        if (activeFeature){
            if (activeFeature.name == "BOOSTED_BET"){
                return true;
            }
        }
        return false;
    }

    public isNearWinAllowed():boolean {
        return !this.hasWonFsClient && !this.data.wasFeatureBuy;
    }

}